import styled from "@emotion/styled"
import background from "../../images/abstractbackground.jpg"

export const MainContainer = styled.div`
  background: #000;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 15%;
`

export const FormContainer = styled.div`
  width: 70%;

  margin: auto;

  padding: 40px 0px;
  padding-bottom: 187px;
  @media (max-width: 560px) {
    width: 80%;
  }
`

export const Heading = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 41px;
  font-weight: 700;
  line-height: 2em;

  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  background: linear-gradient(
    45deg,
    #405de6,
    #5851db,
    #833ab4,
    #c13584,
    #e1306c,
    #fd1d1d
  );
  background: radial-gradient(
    circle farthest-corner at 0 0,
    #ff61d3 25%,
    #b318ff 45%,
    #00f0ff 65%,
    #3cf7a2 85%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 560px) {
    font-size: 28px;
  }
`

export const Download = styled.a`
  background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%);
  padding: 0 20px;
  height: 54px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Poppins;
  font-weight: 600;
  margin-bottom: 63px;
  width: 400px;
  text-decoration: none;
  @media (max-width: 943px) {
    margin-bottom: 0px;
  }
  @media (max-width: 560px) {
    width: 100%;
    padding: 0px 6px;
    font-size: 14px;
  }

  :hover {
    background: #8957f6;
    /* border: 1px solid #fff; */
    cursor: pointer;
  }
`

export const Astrick = styled.sup`
  color: red;
`

export const Label = styled.label`
  font-family: Poppins, sans-serif;
  font-size: 15px;
  color: #fff;
  margin-left: 9px;
  /* :after {
    content: "*";
    color: red;
  } */
`

export const Item = styled.div`
  font-family: Poppins, sans-serif;
  font-size: 16px;
  cursor: pointer;
  padding: 10px;
  padding-left: 22px;

  :hover {
    background: #dcdcdc;
  }
`

export const DropdownContainer = styled.div`
  border: 2px solid #d9d9d9;
  padding: 30px 0px;
  padding-top: 20px;
  border-radius: 20px;
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  position: absolute;
  top: 54px;
  width: 100%;
  z-index: 1;
  background: aliceblue;
  @media (max-width: 560px) {
    top: 52px;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  ::-webkit-scrollbar {
    display: none;
    /* width: 12px; */
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
`

export const CustomSelect = styled.div`
  box-sizing: border-box;
  margin-top: 6px;
  height: 39px;
  position: relative;
  padding: 4px 22px;
  z-index: 2;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  width: 100%;
  background-image: none;
  border: 2px solid #d9d9d9;
  border-radius: 50px;
  transition: all 0.3s;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  border-bottom-left-radius: ${props => (props.open ? "0px" : "50px")};
  border-bottom-right-radius: ${props => (props.open ? "0px" : "50px")};
  @media (max-width: 560px) {
    border-radius: 30px;
    border-bottom-left-radius: ${props => (props.open ? "0px" : "30px")};
    border-bottom-right-radius: ${props => (props.open ? "0px" : "30px")};
  }
  &:active {
    outline: none;
  }
  &:invalid {
    color: gray;
  }
`

export const ArrowContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 6px;
  right: 22px;
  transition: all 0.4s ease;
`

export const Text = styled.div`
  margin-top: 20px;
  font-family: Poppins, sans-serif;
  font-size: 15px;
  color: red;
`

export const SubmitButton = styled.button`
  width: 200px;
  height: 50px;
  border-radius: 50px;
  border: none;
  margin-top: 21px;
  align-items: center;
  justify-content: center;
  font-family: Poppins, sans-serif;
  color: #fff;
  cursor: pointer;
  background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%);
  :hover {
    color: #fff;
  }
`

export const Textarea = styled.textarea`
  margin-top: 6px;
  box-sizing: border-box;
  height: 39px;
  padding: 4px 22px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  width: 100%;
  background-image: none;
  border: 2px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  outline: none;
  border-radius: 50px;
  font-family: Poppins, sans-serif;
  font-size: 16px;

  &:active {
    outline: none;
  }
`

export const CustomInput = styled.input`
  margin-top: 6px;
  box-sizing: border-box;
  height: 39px;
  padding: 4px 22px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  width: 100%;
  background-image: none;
  border: 2px solid #d9d9d9;
  border-radius: 2px;
  transition: all 0.3s;
  outline: none;
  border-radius: 50px;
  font-family: Poppins, sans-serif;
  font-size: 16px;

  &:active {
    outline: none;
  }
`

export const InputContainer = styled.div`
  width: 48%;
  position: relative;
  @media (max-width: 943px) {
    margin-top: 30px;
    width: 100%;
  }
`

export const InputFlex = styled.div`
  display: flex;

  align-items: flex-start;

  justify-content: space-between;

  margin-bottom: 14px;
  margin-top: 60px;
  @media (max-width: 943px) {
    flex-direction: column;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`
